import React from "react";
import * as Icons from "lucide-react";
import { trustBadges } from "@/mock";

export default function TrustBar() {
  return (
    <section className="bg-[#f4f4f2] border-y border-black/10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-6 grid grid-cols-2 md:grid-cols-4 gap-6">
        {trustBadges.map((b) => {
          const Icon = Icons[b.icon] || Icons.Check;
          return (
            <div key={b.title} className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-full bg-white border border-black/10 flex items-center justify-center shrink-0 shadow-sm">
                <Icon size={20} className="text-[#c60d0d]" strokeWidth={2.2} />
              </div>
              <div>
                <div className="text-[12px] font-black tracking-[0.12em] uppercase text-black">
                  {b.title}
                </div>
                <div className="text-[12px] text-black/60">{b.sub}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
